import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
import Home from '../views/Home.vue'
import empleados from '../views/Empleados/index.vue'
import empleados_id from '../views/Empleados/Empleado.vue'
import cotizacion from '../views/Cotizacion/Nueva.vue'
import cotizacion_id from '../views/Cotizacion/index.vue'
import cotizacion_confirmado from '../views/Cotizacion/Confirmacion.vue'
import Ordenes from '../views/Ordenes.vue' 

import clientes from '../views/Clientes/index.vue'
import profile_id from '../views/Profile.vue'
import cliente_id from '../views/Clientes/Cliente.vue'
import Login from '../views/Login.vue'
import tarifas from '../views/Tarifas.vue'
import ciudades from '../views/Ciudades.vue'
import marcas from '../views/Marcas.vue'
import products from '../views/Products/index.vue'
import product_id from '../views/Products/Product.vue'
import Empresas from '../views/Empresas.vue'
import paquetes from '../views/Paquetes.vue' 

import NoServicio from '../views/NoServicio/index.vue' 
import NoServicio_id from '../views/NoServicio/servicio.vue' 
import Config_Home from '../views/config/home.vue'

import datacotizaciones from '../views/DataCotizaciones.vue'
Vue.use(Router)

var router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/inicio',
      name: 'home',
      component: Home,
      meta: {
        Administrador: true,
        Supervisor: true,
        Vendedor: true
      }
    },
    {
      path: '/data',
      name: 'datacotizaciones',
      component: datacotizaciones,
      meta: {
        Administrador: true, 
      }
    },
    {
      path: '/profile',
      name: 'profile_id', 
      component: profile_id,
      meta: {
        Administrador: true,
        Supervisor: true,
        Vendedor: true
      }
    },
    {
      path: '/clientes',
      name: 'clientes',
      component: clientes,
      props: true,
      meta: {
        Administrador: true,
        Supervisor: true,
        Vendedor: true
      }
    },
    {
      path: '/cliente/:id',
      name: 'cliente_id',
      props: true,
      component: cliente_id,
      meta: {
        Administrador: true,
        Supervisor: true,
        Vendedor: true
      }
    },
    {
      path: '/empleados',
      name: 'empleados',
      component: empleados,
      meta: {
        Administrador: true,
        Supervisor: true
      }
    },
    {
      path: '/empleados/:id',
      name: 'empleados_id',
      component: empleados_id,
      meta: {
        Administrador: true, 
        Supervisor: true
      }
    },
    {
      path: '/cotizacion',
      name: 'cotizacion',
      component: cotizacion_id,
      meta: {
        Administrador: true, 
        Supervisor: true,
        Vendedor: true
      }
    },
    {
      path: '/cotizacion/:id',
      name: 'cotizacion_id',
      component: cotizacion_id,
      meta: {
        Administrador: true, 
        Supervisor: true,
        Vendedor: true
      }
    },
    {
      path: '/cotizacion/:id/confirmado',
      name: 'cotizacion_confirmado',
      component: cotizacion_confirmado,
      meta: {
        Administrador: true, 
        Supervisor: true,
        Vendedor: true
      }
    },
    {
      path: '/tarifas',
      name: 'tarifas',
      component: tarifas,
      meta: {
        Administrador: true
      }
    },
    {
      path: '/marcas',
      name: 'marcas',
      component: marcas,
      meta: {
        Administrador: true
      }
    },
    {
      path: '/ciudades',
      name: 'ciudades',
      component: ciudades,
      meta: {
        Administrador: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        libre: true
      }
    },
    {
      path:'/products',
      name:'products',
      component:products,
      meta:{
        Administrador:true
      }
    },
    {
      path:'/product/:id',
      name:'product_id',
      component:product_id,
      meta:{
        Administrador:true
      }
    },
    {
      path: '/empresas',
      name: 'empresas',
      component: Empresas,
      meta: {
        Administrador: true
      }
    },
    {
      path:'/paquetes',
      name:'paquetes',
      component:paquetes,
      meta:{
        Administrador:true
      }
    }, 
    {
      path:'/Ordenes',
      name:'Ordenes',
      component:Ordenes,
      meta:{
        Administrador:true
      }
    }, 
    {
      path:'/config/home',
      name:'Config_Home',
      component:Config_Home,
      meta:{
        Administrador:true
      }
    }, 
    {
      path:'/NoServicio',
      name:'NoServicio',
      component:NoServicio,
      meta:{
        Administrador:true
      }
    }, 
    {
      path:'/NoServicio/:id',
      name:'NoServicio_id',
      component:NoServicio_id,
      meta:{
        Administrador:true
      }
    }, 
   
  ]
})
 
router.beforeEach((to, from, next) => {   
  if (to.matched.some(record => record.meta.libre)){
    next();
  } else if ( store.state.usuario && store.state.usuario.rol == 'Administrador'){
    if (to.matched.some(record => record.meta.Administrador)){
      next();
    }
  } else if ( store.state.usuario && store.state.usuario.rol == 'Vendedor'){
    if (to.matched.some(record => record.meta.Vendedor)){
      next();
    }
  } else if ( store.state.usuario && store.state.usuario.rol == 'Supervisor'){
    console.log("Entra");
    if (to.matched.some(record => record.meta.Supervisor)){
      next();
    }
  } else{
    next({name: 'login'});
  }
})
export default router
